import type { CSSProperties } from 'react';

export const C = {
  ink: '#12262B',
  inkDark: '#0E1A1A',
  brand: '#15A08C',
  brandDark: '#0F6E56',
  brandBg: '#E1F5EE',
  tealTint: '#E1F5EE',
  tealInk: '#0F6E56',
  page: '#F4F6F8',
  card: '#FFFFFF',
  line: '#E7EAF0',
  amberBg: '#FEF6E7',
  amberInk: '#A67312',
  muted: '#66748B',
} as const;

export const tabular: CSSProperties = {
  fontVariantNumeric: 'tabular-nums',
};